const steps = [
  {
    icon: 'ri-list-check-2',
    title: '第一步 · 明确方向',
    desc: '先确定今天想看的是电影还是电视剧，再从动作、科幻、悬疑等类型中挑一个方向，避免在片库里漫无目的地刷。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '第二步 · 筛选片库',
    desc: '在片库检索区用关键词或类型标签筛选，切换电影 / 剧集后即可看到对应结果，还能按「查看更多」逐步展开。',
  },
  {
    icon: 'ri-trophy-line',
    title: '第三步 · 参考榜单',
    desc: '拿不定主意时，翻一翻口碑榜单和编辑精选，用评分、题材与一句话简介快速判断是否合口味。',
  },
];

const tips = [
  '追剧党可以先看剧集分区的集数与更新状态',
  '想省时间就从免费专区里挑，内容同样经过整理',
  '片名记不全时，输入类型或标签关键词往往更有效',
];

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-route-line"></i>
            选片指南
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            三步在 555电影 找到想看的片子
          </h2>
          <p className="max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            片库内容多，方法比运气更重要。按照下面三步走，通常几分钟就能锁定目标，而不是在列表里反复滑动。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {steps.map((step, index) => (
            <div key={step.title} className="relative flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="absolute right-5 top-5 font-heading text-3xl font-black text-background-300">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${step.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-6">
          <h3 className="font-heading text-base font-bold text-foreground-950">几个实用小提示</h3>
          <ul className="grid grid-cols-1 gap-3 md:grid-cols-3">
            {tips.map((tip) => (
              <li key={tip} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center text-secondary-700">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                </span>
                {tip}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}